import {createContext} from "react";
import {INotificationContext} from "./models/INotificationContext.ts";

export const NotificationContext = createContext<INotificationContext>({
    isNotificationVisible: false,
    notificationData: {
        description: "",
        status: undefined,
        title: "",
    },
    setIsNotificationVisible: () => {},
    showNotification: () => {},
});